// import { IGoogleSpeechToTextRecognitionOptions } from './types';

/**
 * Endpoint used for fetching the tenant config JSON object with the provided `identifier`.
 */
export const googleSpeechToTextUrl = () => './api/google/speech-to-text';
